import { UPLOADED_BATCH_OFFER_VISIBLE_MS } from '~/components/v2/components/workspace/workspace-agent-panel/uploaded-batch-offer/isUploadedBatchOfferVisible';
import { type FinishedUploadBatch } from '~/components/v2/components/workspace/workspace-agent-panel/uploaded-batch-offer/useUploadedBatchOfferStore';

export type PickUploadedBatchOfferBatchParams = {
  importBatch: FinishedUploadBatch | null;
  now: number;
  resolvedBatchIds: ReadonlySet<string>;
  uploadBatch: FinishedUploadBatch | null;
};

const isBatchOfferable = (batch: FinishedUploadBatch, now: number, resolvedBatchIds: ReadonlySet<string>) =>
  !resolvedBatchIds.has(batch.batchId) && now < batch.finishedAt + UPLOADED_BATCH_OFFER_VISIBLE_MS;

/** One pill at a time: an upload still inside its window wins over an import. */
export const pickUploadedBatchOfferBatch = ({
  importBatch,
  now,
  resolvedBatchIds,
  uploadBatch,
}: PickUploadedBatchOfferBatchParams): FinishedUploadBatch | null => {
  if (uploadBatch && isBatchOfferable(uploadBatch, now, resolvedBatchIds)) {
    return uploadBatch;
  }

  if (importBatch && isBatchOfferable(importBatch, now, resolvedBatchIds)) {
    return importBatch;
  }

  return null;
};
